import { render, staticRenderFns } from "./ModalDeletePersonalizationValue.vue?vue&type=template&id=c2ee9d3e&scoped=true"
import script from "./ModalDeletePersonalizationValue.vue?vue&type=script&lang=js"
export * from "./ModalDeletePersonalizationValue.vue?vue&type=script&lang=js"
import style0 from "./ModalDeletePersonalizationValue.vue?vue&type=style&index=0&id=c2ee9d3e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ee9d3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2ee9d3e')) {
      api.createRecord('c2ee9d3e', component.options)
    } else {
      api.reload('c2ee9d3e', component.options)
    }
    module.hot.accept("./ModalDeletePersonalizationValue.vue?vue&type=template&id=c2ee9d3e&scoped=true", function () {
      api.rerender('c2ee9d3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/personalization/ModalDeletePersonalizationValue.vue"
export default component.exports